// extracted by mini-css-extract-plugin
export var boxItems = "_1u-1";
export var boxItemsLg = "_1u-2";
export var button = "_1u-7";
export var buttonHoverless = "_1u-9";
export var buttonLg = "_1u-8";
export var filterGroupBox = "_1u-0";
export var icon = "_1u-3";
export var iconSecondary = "_1u-6";
export var iconWrapper = "_1u-4";
export var iconWrapperLg = "_1u-5";
export var truncatedLabel = "_1u-a";